<template>
  <div class="auth-wrap">
    <div class="auth-card">
      <div class="auth-logo">Mobi<span>FIX</span> PRO</div>
      <h1 class="auth-title">Створити акаунт</h1>
      <p class="auth-sub">Реєстрація займе менше хвилини</p>

      <div v-if="error" class="auth-error">{{ error }}</div>

      <form @submit.prevent="handleRegister" class="auth-form">
        <div class="auth-field">
          <label class="auth-label">Ваше ім'я</label>
          <input v-model="form.name" type="text" required class="auth-input" placeholder="Іван Іванов" />
        </div>
        <div class="auth-field">
          <label class="auth-label">Номер телефону</label>
          <input v-model="form.phone" type="tel" required class="auth-input" placeholder="+38 (0XX) XXX-XX-XX" />
        </div>
        <div class="auth-field-row">
          <div class="auth-field">
            <label class="auth-label">Пароль</label>
            <input v-model="form.password" type="password" required minlength="6" class="auth-input" placeholder="Мінімум 6 символів" />
          </div>
          <div class="auth-field">
            <label class="auth-label">Повторіть пароль</label>
            <input v-model="form.confirmPassword" type="password" required minlength="6" class="auth-input" placeholder="Ще раз" />
          </div>
        </div>

        <!-- Реферальний код -->
        <div class="auth-field">
          <label class="auth-label">
            Реферальний код
            <span class="auth-optional">(необов'язково)</span>
          </label>
          <div class="auth-ref-wrap">
            <span class="auth-ref-icon">🎁</span>
            <input v-model="form.referralCode" type="text" class="auth-input auth-ref-input"
              placeholder="Код від друга — отримай знижку" style="text-transform:uppercase" />
          </div>
          <div class="auth-ref-hint">Введи реферальний код друга і отримай -50 грн на перший ремонт</div>
        </div>

        <div class="auth-agree">
          <label class="auth-agree-label">
            <input type="checkbox" v-model="agreed" class="auth-check" />
            <span>Я погоджуюсь з <a href="#" class="auth-agree-link">умовами використання</a> та <a href="#" class="auth-agree-link">політикою конфіденційності</a></span>
          </label>
        </div>

        <button type="submit" :disabled="loading || !agreed" class="auth-btn">
          <span class="auth-spin" v-if="loading"></span>
          {{ loading ? 'Реєструємось...' : 'Створити акаунт' }}
        </button>
      </form>

      <div class="auth-divider"><span>або</span></div>
      <div class="auth-switch">
        Вже є акаунт? <router-link to="/login" class="auth-switch-link">Увійти</router-link>
      </div>
    </div>

    <div class="auth-side">
      <div class="auth-side-content">
        <div class="auth-side-icon">🎉</div>
        <h2>Ласкаво просимо!</h2>
        <p>Створіть акаунт і отримайте доступ до всіх можливостей MobiFIX PRO</p>
        <div class="auth-benefits">
          <div class="auth-benefit">
            <div class="auth-benefit-icon">📱</div>
            <div>
              <div class="auth-benefit-title">Відстеження в реальному часі</div>
              <div class="auth-benefit-desc">Дивись на якому етапі ремонт прямо зараз</div>
            </div>
          </div>
          <div class="auth-benefit">
            <div class="auth-benefit-icon">🎁</div>
            <div>
              <div class="auth-benefit-title">Програма лояльності</div>
              <div class="auth-benefit-desc">Запрошуй друзів — отримуй 10% кешбек від їх ремонтів</div>
            </div>
          </div>
          <div class="auth-benefit">
            <div class="auth-benefit-icon">💰</div>
            <div>
              <div class="auth-benefit-title">Бонусні гривні</div>
              <div class="auth-benefit-desc">Накопичуй бонуси і оплачуй до 50% ремонту</div>
            </div>
          </div>
          <div class="auth-benefit">
            <div class="auth-benefit-icon">📋</div>
            <div>
              <div class="auth-benefit-title">Історія замовлень</div>
              <div class="auth-benefit-desc">Всі ваші ремонти в одному місці</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';

export default {
  name: 'RegisterPage',
  setup() {
    const router = useRouter();
    const authStore = useAuthStore();
    const form = ref({ name: '', phone: '', password: '', confirmPassword: '', referralCode: '' });
    const loading = ref(false);
    const error = ref('');
    const agreed = ref(false);

    const handleRegister = async () => {
      error.value = '';
      if (!form.value.name.trim()) { error.value = 'Введіть ім\'я'; return; }
      if (!form.value.phone.trim()) { error.value = 'Введіть номер телефону'; return; }
      if (form.value.password !== form.value.confirmPassword) { error.value = 'Паролі не збігаються'; return; }
      if (form.value.password.length < 6) { error.value = 'Пароль повинен бути не менше 6 символів'; return; }
      loading.value = true;
      try {
        await authStore.register(
          form.value.name,
          form.value.phone,
          form.value.password,
          form.value.referralCode
        );
        router.push('/');
      } catch (err) { error.value = err || 'Помилка реєстрації. Спробуйте пізніше'; }
      finally { loading.value = false; }
    };

    return { form, loading, error, agreed, handleRegister };
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }
.auth-wrap { display: grid; grid-template-columns: 1fr 1fr; min-height: calc(100vh - 60px); margin: -2.5rem -2rem; }
.auth-card { display: flex; flex-direction: column; justify-content: center; padding: 3rem; background: #fff; }
.auth-logo { font-size: 20px; font-weight: 800; color: #534ab7; margin-bottom: 2rem; }
.auth-logo span { color: #1d9e75; }
.auth-title { font-size: 26px; font-weight: 800; color: #26215c; margin-bottom: 6px; }
.auth-sub { font-size: 14px; color: #666; margin-bottom: 2rem; }
.auth-error { background: #ffeaea; border: 1px solid #f5c6c6; color: #c0392b; border-radius: 10px; padding: 12px 16px; font-size: 14px; margin-bottom: 1.25rem; }
.auth-form { display: flex; flex-direction: column; gap: 1.25rem; }
.auth-field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
.auth-field { display: flex; flex-direction: column; gap: 6px; }
.auth-label { font-size: 13px; font-weight: 700; color: #444; display: flex; gap: 6px; align-items: center; }
.auth-optional { font-weight: 400; color: #aaa; font-size: 11px; }
.auth-input { background: #f4f3ff; border: 1.5px solid #e0dff8; border-radius: 10px; padding: 12px 16px; color: #26215c; font-size: 15px; outline: none; transition: border-color 0.15s; width: 100%; }
.auth-input:focus { border-color: #534ab7; background: #fff; }
.auth-ref-wrap { position: relative; display: flex; align-items: center; }
.auth-ref-icon { position: absolute; left: 14px; font-size: 16px; z-index: 1; }
.auth-ref-input { padding-left: 38px; }
.auth-ref-hint { font-size: 11px; color: #1d9e75; font-weight: 600; margin-top: 2px; }
.auth-agree { display: flex; align-items: flex-start; }
.auth-agree-label { display: flex; gap: 10px; cursor: pointer; font-size: 13px; color: #666; line-height: 1.5; }
.auth-check { flex-shrink: 0; width: 18px; height: 18px; accent-color: #534ab7; margin-top: 2px; }
.auth-agree-link { color: #534ab7; }
.auth-btn { background: linear-gradient(135deg, #534ab7, #7f77dd); color: #fff; border: none; padding: 13px; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 4px 20px rgba(83,74,183,0.3); transition: transform 0.2s; }
.auth-btn:hover:not(:disabled) { transform: translateY(-2px); }
.auth-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.auth-spin { width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.4); border-top-color: #fff; border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.auth-divider { text-align: center; position: relative; margin: 1.5rem 0; }
.auth-divider::before { content: ''; position: absolute; top: 50%; left: 0; right: 0; height: 1px; background: #e0dff8; }
.auth-divider span { background: #fff; padding: 0 12px; font-size: 13px; color: #bbb; position: relative; }
.auth-switch { text-align: center; font-size: 14px; color: #666; }
.auth-switch-link { color: #534ab7; font-weight: 700; text-decoration: none; }
.auth-switch-link:hover { text-decoration: underline; }

.auth-side { background: linear-gradient(135deg, #26215c, #1a3a2a); display: flex; align-items: center; justify-content: center; padding: 3rem; }
.auth-side-content { color: #fff; max-width: 340px; }
.auth-side-icon { font-size: 52px; margin-bottom: 1.5rem; }
.auth-side-content h2 { font-size: 28px; font-weight: 800; margin-bottom: 1rem; }
.auth-side-content p { font-size: 15px; color: rgba(255,255,255,0.65); line-height: 1.7; margin-bottom: 2rem; }
.auth-benefits { display: flex; flex-direction: column; gap: 1.25rem; }
.auth-benefit { display: flex; align-items: flex-start; gap: 12px; }
.auth-benefit-icon { font-size: 24px; flex-shrink: 0; width: 44px; height: 44px; background: rgba(255,255,255,0.1); border-radius: 12px; display: flex; align-items: center; justify-content: center; }
.auth-benefit-title { font-size: 14px; font-weight: 700; margin-bottom: 3px; }
.auth-benefit-desc { font-size: 12px; color: rgba(255,255,255,0.55); }

@media (max-width: 700px) {
  .auth-wrap { grid-template-columns: 1fr; }
  .auth-side { display: none; }
  .auth-card { padding: 2rem 1.5rem; }
  .auth-field-row { grid-template-columns: 1fr; }
}
</style>
